import React, { Fragment } from "react";
import { connect } from "react-redux";
import cx from "classnames";
import { withRouter } from "react-router-dom";
import ResizeDetector from "react-resize-detector";
import { GoogleOAuthProvider } from "@react-oauth/google";

import AppMain from "./layout/AppMain";
import AppHelmet from "./components/AppHelmet";
import { load_page_config_json } from "./actions/myprofile/action";
import "./i18n";
import MyModal from "./components/MyModel";
import service from "./utils/service";

class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      closedSmallerSidebar: false,
      authConfig: null,
      googleClientId: null,
    };
  }

  componentDidMount() {
    const { load_page_config_json } = this.props;
    load_page_config_json();
    this.fetchAuthConfig();
  }

  fetchAuthConfig = async () => {
    try {
      const response = await service.get("v4/configs/auth");

      const auth = response?.data?.auth;

      this.setState({
        authConfig: auth,
        googleClientId: auth?.google?.clientId,
      });
    } catch (err) {
      console.error("Failed to load auth config", err);
    }
  };

  render() {
    let {
      colorScheme,
      enableFixedHeader,
      enableFixedSidebar,
      enableFixedFooter,
      enableClosedSidebar,
      enableMobileMenu,
      enablePageTabsAlt,
    } = this.props;

    const { closedSmallerSidebar, googleClientId } = this.state;

    if (!googleClientId) {
      return (
        <div className="vh-100 d-flex justify-content-center align-items-center">
          Loading Authentication ...
        </div>
      );
    }

    return (
      <GoogleOAuthProvider clientId={googleClientId}>
        <ResizeDetector
          handleWidth
          render={({ width }) => (
            <Fragment>
              <div
                className={cx(
                  "app-container app-theme-" + colorScheme,
                  { "fixed-header": enableFixedHeader },
                  { "fixed-sidebar": enableFixedSidebar || width < 1250 },
                  { "fixed-footer": enableFixedFooter },
                  { "closed-sidebar": enableClosedSidebar || width < 1250 },
                  {
                    "closed-sidebar-mobile":
                      closedSmallerSidebar || width < 1250,
                  },
                  { "sidebar-mobile-open": enableMobileMenu },
                  { "body-tabs-shadow-btn": enablePageTabsAlt }
                )}
              >
                <AppMain />
                <AppHelmet />
                <MyModal />
              </div>
            </Fragment>
          )}
        />
      </GoogleOAuthProvider>
    );
  }
}

const mapStateToProp = (state) => ({
  colorScheme: state.ThemeOptions.colorScheme,
  enableFixedHeader: state.ThemeOptions.enableFixedHeader,
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
  enableFixedFooter: state.ThemeOptions.enableFixedFooter,
  enableFixedSidebar: state.ThemeOptions.enableFixedSidebar,
  enableClosedSidebar: state.ThemeOptions.enableClosedSidebar,
  enablePageTabsAlt: state.ThemeOptions.enablePageTabsAlt,
});

const mapDispatchToProps = (dispatch) => ({
  load_page_config_json: () => dispatch(load_page_config_json()),
});

export default withRouter(
  connect(mapStateToProp, mapDispatchToProps)(Main)
);